import { render, staticRenderFns } from "./MyTodoModal.vue?vue&type=template&id=10dc45d0&scoped=true&"
import script from "./MyTodoModal.vue?vue&type=script&lang=js&"
export * from "./MyTodoModal.vue?vue&type=script&lang=js&"
import style0 from "./MyTodoModal.vue?vue&type=style&index=0&id=10dc45d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc45d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10dc45d0')) {
      api.createRecord('10dc45d0', component.options)
    } else {
      api.reload('10dc45d0', component.options)
    }
    module.hot.accept("./MyTodoModal.vue?vue&type=template&id=10dc45d0&scoped=true&", function () {
      api.rerender('10dc45d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BPMeletronicSigned/modules/MyTodoModal.vue"
export default component.exports